export const url = (url: string) => `http://localhost${url}`;
